import {StyleParamType, createStylesParams} from '@wix/tpa-settings'

import {Alignment, Direction, ImageSize} from '../../../../../../types/createStylesParams'
import {
  ALIGNMENT_DESCRIPTION,
  DIRECTION_DESCRIPTION,
  IMAGE_SIZE_DESCRIPTION,
  numberEnumMetadata,
} from '../../../../../../utils/builderMetadata'

export type HeaderLayoutStylesParams = {
  breadcrumbsAlignment: StyleParamType.Number
  titleAndSubtitleAlignment: StyleParamType.Number
  detailsBoxAlignment: StyleParamType.Number
  detailsBoxCellStretch: StyleParamType.Number
  detailsBoxTextAlignment: StyleParamType.Number
  headerButtonAlignment: StyleParamType.Number
  imageAlignment: StyleParamType.Number
  imageSize: StyleParamType.Number
}

export const headerLayoutStylesParams = createStylesParams<HeaderLayoutStylesParams>({
  breadcrumbsAlignment: {
    type: StyleParamType.Number,
    getDefaultValue: () => Alignment.Left,
    metadata: numberEnumMetadata({defaultValue: Alignment.Left}, ALIGNMENT_DESCRIPTION),
  },
  titleAndSubtitleAlignment: {
    type: StyleParamType.Number,
    getDefaultValue: () => Alignment.Center,
    metadata: numberEnumMetadata({defaultValue: Alignment.Center}, ALIGNMENT_DESCRIPTION),
  },
  detailsBoxAlignment: {
    type: StyleParamType.Number,
    getDefaultValue: () => Alignment.Stretch,
  },
  detailsBoxCellStretch: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
  },
  detailsBoxTextAlignment: {
    type: StyleParamType.Number,
    getDefaultValue: () => Alignment.Center,
    metadata: numberEnumMetadata({defaultValue: Alignment.Center}, ALIGNMENT_DESCRIPTION),
  },
  headerButtonAlignment: {
    type: StyleParamType.Number,
    getDefaultValue: () => Alignment.Center,
    metadata: numberEnumMetadata({defaultValue: Alignment.Center}, ALIGNMENT_DESCRIPTION),
  },
  imageAlignment: {
    type: StyleParamType.Number,
    getDefaultValue: () => Direction.Normal,
    metadata: numberEnumMetadata({defaultValue: Direction.Normal}, DIRECTION_DESCRIPTION),
  },
  imageSize: {
    type: StyleParamType.Number,
    getDefaultValue: () => ImageSize.Crop,
    metadata: numberEnumMetadata({defaultValue: ImageSize.Crop}, IMAGE_SIZE_DESCRIPTION),
  },
})
